module.exports = __webpack_public_path__ + "static/media/1.60777683.jpg";